import * as vp from 'vopay';
import { useTranslation } from 'react-i18next';

type UpdateWebhookRows = {
  label: string;
  id: vp.UpdateWebhookId;
  preset: keyof vp.TextFieldPresets | undefined;
  required: boolean;
};

const useBuildUpdateWebhookRows = (): UpdateWebhookRows[] => {
  const { t } = useTranslation('translations', { keyPrefix: 'Settings.Webhooks.Update.Form' });
  return [
    {
      label: t('accountStatusWebHookURL', { defaultValue: 'Account Status' }),
      id: vp.UpdateWebhookId.AccountStatusWebHookURL,
      preset: 'text',
      required: true,
    },
  ];
};
export default useBuildUpdateWebhookRows;
